import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import {
  MemberPayload,
  MessageMemberResponseType,
  PromotionMemberResponseType,
  VipMemberResponseType,
} from "types/member";

export const memberApi = {
  async getMessageMember(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<MessageMemberResponseType>(
      "/",
      payloadHelper("MemberMessage", username, payload)
    );
    return response.data;
  },

  async getPromotionMember(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<PromotionMemberResponseType>(
      "/",
      payloadHelper("MemberPromotion", username, payload)
    );
    return response.data;
  },
  async getMemberVip(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<VipMemberResponseType>(
      "/",
      payloadHelper("MemberVIP", username, payload)
    );
    return response.data;
  },
};
